import { Grid, Typography } from '@mui/material';
import { EmailField, FunctionField, SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import { AddressDetails, PhoneNumberArrayField } from 'src/lib';
import { Account } from 'src/models';

export const TrustedContactShow = () => {
  const record = useRecordContext<Account>();

  return (
    <Grid container direction='row'>
      {record.type.isJoint && record.jointAccountType?.isTenantsInCommon && (
        <>
          <Grid item xs={12}>
            <SimpleShowLayout>
              <Typography variant='h5'>Tenants in Common</Typography>
            </SimpleShowLayout>
          </Grid>
          <Grid item md={6}>
            <SimpleShowLayout>
              <FunctionField
                render={(record: Account) => `${record.primaryAccountHolder?.jointTenantsInCommonInterestPercent}%`}
                label={`Primary Account Holder (${record.primaryAccountHolder?.firstName} ${record.primaryAccountHolder?.lastName})`}
              />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={6}>
            <SimpleShowLayout>
              <FunctionField
                render={(record: Account) => `${record.secondaryAccountHolder?.jointTenantsInCommonInterestPercent}%`}
                label={`Joint Account Holder (${record.secondaryAccountHolder?.firstName} ${record.secondaryAccountHolder?.lastName})`}
              />
            </SimpleShowLayout>
          </Grid>
        </>
      )}
      {record.primaryAccountHolder?.trustedContact && (
        <>
          <Grid item xs={12}>
            <SimpleShowLayout>
              <Typography variant='h5'>Trusted Contact</Typography>
            </SimpleShowLayout>
          </Grid>
          <Grid item md={12}>
            <Grid container md={6}>
              <Grid item md={5}>
                <SimpleShowLayout>
                  <TextField source='primaryAccountHolder.trustedContact.firstName' label='First Name' />
                </SimpleShowLayout>
              </Grid>
              <Grid item md={2}>
                <SimpleShowLayout>
                  <TextField source='primaryAccountHolder.trustedContact.middleName' label='Middle Name' />
                </SimpleShowLayout>
              </Grid>
              <Grid item md={4}>
                <SimpleShowLayout>
                  <TextField source='primaryAccountHolder.trustedContact.lastName' label='Last name' />
                </SimpleShowLayout>
              </Grid>
              <Grid item md={1}>
                <SimpleShowLayout>
                  <TextField source='primaryAccountHolder.trustedContact.suffix' label='Suffix' />
                </SimpleShowLayout>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6}>
            <SimpleShowLayout>
              <EmailField source='primaryAccountHolder.trustedContact.email' label='Email' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={6}>
            <SimpleShowLayout>
              <PhoneNumberArrayField record={record.primaryAccountHolder?.trustedContact?.phones} />
            </SimpleShowLayout>
          </Grid>
          {record.primaryAccountHolder?.trustedContact?.address && (
            <AddressDetails record={record.primaryAccountHolder.trustedContact.address} />
          )}
        </>
      )}
    </Grid>
  );
};
